<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="cls" :style="innerStyle" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" :stroke-linejoin="strokeLinejoin" @click="onClick"><g clip-path="url(#clip0_748_46447)" stroke="transparent"><g clip-path="url(#clip1_748_46447)"><path d="M3.125 0h10l5 5v13.75c0 .69-.56 1.25-1.25 1.25H3.125c-.69 0-1.25-.56-1.25-1.25V1.25c0-.69.56-1.25 1.25-1.25Z" fill="#00B42A"></path><path opacity=".9" d="M6.928 11.724a.1.1 0 0 1-.1.1H5.103a.1.1 0 0 0-.1.1v1.104a.1.1 0 0 0 .1.1h2.059a.1.1 0 0 1 .1.1v.605a.1.1 0 0 1-.1.1H4.1a.1.1 0 0 1-.1-.1V9.167a.1.1 0 0 1 .1-.1h3.055a.1.1 0 0 1 .1.1v.612a.1.1 0 0 1-.1.1H5.103a.1.1 0 0 0-.1.1v.96a.1.1 0 0 0 .1.1h1.725a.1.1 0 0 1 .1.1v.585Zm2.576-1.14a.1.1 0 0 0 .175 0l.797-1.465a.1.1 0 0 1 .087-.052h.92a.1.1 0 0 1 .085.15L10.27 11.43a.1.1 0 0 0 0 .102l1.334 2.251a.1.1 0 0 1-.086.151h-.932a.1.1 0 0 1-.087-.052l-.82-1.493a.1.1 0 0 0-.175 0l-.82 1.493a.1.1 0 0 1-.088.052h-.931a.1.1 0 0 1-.086-.15l1.334-2.252a.1.1 0 0 0 0-.102L7.615 9.218a.1.1 0 0 1 .086-.151h.919a.1.1 0 0 1 .087.052l.797 1.464Zm6.324 1.728c.058 0 .104.049.097.106a1.994 1.994 0 0 1-.158.576c-.09.203-.222.384-.387.533a1.777 1.777 0 0 1-.6.348 2.397 2.397 0 0 1-.804.125 2.09 2.09 0 0 1-.84-.162 1.72 1.72 0 0 1-.632-.466 2.116 2.116 0 0 1-.398-.737 3.174 3.174 0 0 1-.138-.971v-.321c0-.359.048-.683.143-.973.096-.29.232-.536.407-.738.174-.202.391-.362.636-.468.25-.11.528-.164.836-.164.303 0 .57.043.803.129a1.625 1.625 0 0 1 .974.902c.078.18.132.372.161.577a.097.097 0 0 1-.097.11h-.798a.105.105 0 0 1-.103-.094 1.512 1.512 0 0 0-.066-.29.755.755 0 0 0-.17-.281.698.698 0 0 0-.283-.172 1.33 1.33 0 0 0-.421-.059c-.339 0-.591.123-.757.37-.166.246-.25.627-.25 1.144v.328c0 .252.019.472.056.662.037.189.094.347.173.474.08.127.182.222.308.286a1 1 0 0 0 .457.095c.158 0 .294-.018.409-.053a.726.726 0 0 0 .287-.163.73.73 0 0 0 .18-.272c.032-.085.056-.181.07-.288a.104.104 0 0 1 .102-.093h.803Z" fill="#fff"></path><path d="m13.125 0 5 5h-3.75c-.69 0-1.25-.56-1.25-1.25V0Z" fill="#7BE188"></path></g></g><defs><clipPath id="clip0_748_46447"><path fill="#fff" d="M0 0h20v20H0z"></path></clipPath><clipPath id="clip1_748_46447"><path fill="#fff" d="M0 0h20v20H0z"></path></clipPath></defs></svg>
</template>

<script lang="ts">
import { defineComponent, computed, CSSProperties } from 'vue';
import { getPrefixCls } from '../../_utils/global-config';
import { isNumber } from '../../_utils/is';

export default defineComponent({
  name: 'IconFileExcelColor',
  props: {
    size: {
      type: [Number, String],
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeLinecap: {
      type: String,
      default: 'butt',
      validator: (value: any) => {
        return ['butt', 'round', 'square'].includes(value);
      }
    },
    strokeLinejoin: {
      type: String,
      default: 'miter',
      validator: (value: any) => {
        return ['arcs', 'bevel', 'miter', 'miter-clip', 'round'].includes(value);
      }
    },
    rotate: Number,
    spin: Boolean
  },
  emits: {
    click: (ev: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const prefixCls = getPrefixCls('icon');
    const cls = computed(() => [prefixCls, `${prefixCls}-file-excel-color`, { [`${prefixCls}-spin`]: props.spin }]);
    const innerStyle = computed(() => {
      const styles: CSSProperties = {};
      if (props.size) {
        styles.fontSize = isNumber(props.size) ? `${props.size}px` : props.size;
      }
      if (props.rotate) {
        styles.transform = `rotate(${props.rotate}deg)`;
      }
      return styles;
    });
    const onClick = (ev: MouseEvent) => {
      emit('click', ev);
    };

    return {
      cls,
      innerStyle,
      onClick,
    };
  }
});
</script>
